module.exports = __webpack_public_path__ + "img/HeroFocus3.2627bbf8.jpg";